module.exports = new __parcel__URL__("city-3.9543008e.png").toString();